import { getValue } from "@/src/modals/shared/utils";
import issueHelper from "@/src/shared/store/actionHelpers";

export const ModalEntityEnum = {
  ISSUE: "issue",
  PROJECT: "project",
  OPA: "opa",
  EASY_ATTENDANCE: "easy_attendance",
  MEETING: "meeting",
  RESEND_INVITATION: "resend_invitation",
  EMPTY: "empty",
  ENTITY_ACTIVITY: "easy_entity_activity",
  ICAL_EVENT: "ical_event",
  PBI: "pbi",
  EASY_ONBOARDING: "easy_onboarding",
  NPS_RATING: "nps_rating",
  EASY_AI_COLLECTION_PERMISSION: "easy_ai_collection_permission",
  EASY_AI_UPDATE_COLLECTIONS: "easy_ai_update_collections",
  EASY_AI_NEW_PROJECT_STATUS_REPORT: "easy_ai_new_project_status_report",
  REQUIRED_ISSUE_FIELDS: "required_issue_fields",
  NEWS_ONBOARDING: "news_onboarding",
  LOG_TIME: "log_time",
  TRANSLATION: "translation",
  AUTOMATION: "automation",
  PROJECT_CUSTOM_FIELD_VALUES: "project_custom_field_values",
};

export const ModalEntityState = {
  INIT: "init",
  OPENED: "opened",
  CLOSED: "closed",
};

export const ModalAttendanceApprovalApi = {
  approve: "1",
  reject: "0",
};

export const ModalAttendanceStatusOptions = {
  waitingForApproval: "1",
  approved: "2",
  rejected: "3",
  cancelRequest: "4",
  canceled: "5",
};

export const issueAttributeMap = {
  priority: { requestBodyFieldName: "priority_id", valueFunc: issueHelper.getPriority || null },
  assignedTo: { requestBodyFieldName: "assigned_to_id", valueFunc: null },
  author: { requestBodyFieldName: "author_id", valueFunc: null },
  version: { requestBodyFieldName: "fixed_version_id", valueFunc: null },
  easySprint: { requestBodyFieldName: "easy_sprint_id", valueFunc: null },
  easyStoryPoints: {
    requestBodyFieldName: "easy_story_points",
    valueFunc: getValue,
  },
  category: { requestBodyFieldName: "category_id", valueFunc: null },
  status: { requestBodyFieldName: "status_id", valueFunc: null },
  tracker: { requestBodyFieldName: "tracker_id", valueFunc: null },
  activity: {
    requestBodyFieldName: "activity_id",
    fieldName: "activity",
    valueFunc: null,
  },
  easyProductBacklogBoard: {
    requestBodyFieldName: "easy_product_backlog_board_id",
    valueFunc: null,
  },
  estimatedHours: { requestBodyFieldName: "estimated_hours", valueFunc: getValue || null },
  subject: { requestBodyFieldName: "subject", fieldName: "subject", valueFunc: null },
};

export const projectAttributeMap = {
  author: { requestBodyFieldName: "author_id", valueFunc: null },
  startDate: { requestBodyFieldName: "start_date", valueFunc: getValue || null },
  dueDate: { requestBodyFieldName: "due_date", valueFunc: getValue || null },
};
